import { styled } from '@mui/material/styles';
import { keyframes } from '@mui/system';
import { TURN_STYLES } from '@/styles/theme';
import { TurnLogoTrimmed } from '@/svgs';

export const Wrapper = styled('div')({
  display: 'grid',
  placeItems: 'center',
});

export const ImageContainer = styled('div')({
  width: '60px',
  height: '60px',
  marginRight: '0',
});

const spinner = keyframes`
  0% {
    transform: rotateY(0deg);
  }

  50% {
    transform: rotateY(-360deg);
  }

  100% {
    transform: rotateY(-360deg);
  }
`;

export const Logo = styled(TurnLogoTrimmed)({
  width: '100%',
  height: '100%',
  fill: TURN_STYLES.primaryAccentColor,

  animation: `${spinner} 3s ease-in-out infinite`,
});
